import { useLocation, useNavigate } from "react-router-dom";
import React, { Fragment, useContext } from "react";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon from "./Icon";
import { PillarNavigationType } from "../types/Roadmap";
import { StyledText, TextSize } from "./Text";
import Button from "./Button";
import { LocationInterface } from "./UtilsComponents";
import { UserContext } from "../context/UserContext";
import theme from "../styles/theme";

const UIText = styled.span<{ color?: string }>`
  ${({ theme }) => theme.typography.UIText}
  margin : 0px;
  color: ${({ color, theme }) =>
    color ? color : theme.color.lightBlueGray500};
  font-weight: bold;
  font-size: small;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
`;
const ActiveButton = styled(Button)`
  margin-right: 8px;
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  min-width: 190px;
  max-width: 190px;
  background: ${theme.color.blueButton};
`;
const DefaultButton = styled(Button)`
  margin-right: 8px;
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  min-width: 190px;
  max-width: 190px;
`;
type PillarNavigatorProps = {
  path: PillarNavigationType;
};

const PillarNavigator = ({
  path,
  ...props
}: PillarNavigatorProps & React.HTMLProps<HTMLDivElement>): JSX.Element => {
  const navigate = useNavigate();
  let location = useLocation() as LocationInterface;
  const { isModified, setModified, isOpen, setOpen } = useContext(UserContext);

  function isLocationClicked(strMatch: string) {
    let strLocation = location.pathname.split("/");
    if (strLocation[strLocation.length - 1] === strMatch) {
      return true;
    }
    return false;
  }
  console.log("subdomain is", path.subdomains);
  return (
    <FlexBox>
      <Fragment>
        <FlexBox
          alignItems="start"
          className="visible-scrollbar"
          style={{
            flexWrap: "nowrap",
            overflowX: "auto",
            position: "absolute",
            right: "12px",
            left: "12px",
            background: "white",
            // borderBottom: "1px black solid",
            padding: "12px 20px",
          }}
        >
          <>
            {path && path.id !== "" ? (
              <ActiveButton
                title={path.title !== "" ? path.title : ""}
                onClick={() =>
                  isModified
                    ? setOpen(true)
                    : navigate(`/modify/pillar/${path.id}`)
                }
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText color="white">Pillar</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="white" textSize={TextSize.small}>
                      {path.title}
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </ActiveButton>
            ) : (
              <DefaultButton
                onClick={() =>
                  isModified ? setOpen(true) : navigate(`/modify/pillar`)
                }
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText>Pillar</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="gray" textSize={TextSize.small}>
                      Select pillar
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </DefaultButton>
            )}
            <Icon
              style={{ alignSelf: "center" }}
              name="navigate_next"
              color="black"
              size={2.5}
              fixedWidth={false}
            />
            {(path && path.subdomains && path.subdomains.id !== "") ||
            isLocationClicked("subdomain") ? (
              <ActiveButton
                title={
                  path.subdomains.title !== ""
                    ? path.subdomains.title
                    : "Select subdomain"
                }
                onClick={() =>
                  isModified && path.id !== ""
                    ? setOpen(true)
                    : path.subdomains.id !== ""
                    ? navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}`
                      )
                    : navigate(`/modify/pillar/${path.id}/subdomain`)
                }
                onDoubleClick={() => {
                  navigate(`/modify/pillar/${path.id}/subdomain`);
                }}
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText color="white">Subdomain</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="white" textSize={TextSize.small}>
                      {path.subdomains.title !== ""
                        ? path.subdomains.title
                        : "Select subdomain"}
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </ActiveButton>
            ) : (
              <DefaultButton
                onClick={() =>
                  isModified && path.id !== ""
                    ? setOpen(true)
                    : navigate(`/modify/pillar/${path.id}/subdomain`)
                }
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText>Subdomain</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="gray" textSize={TextSize.small}>
                      Select subdomains
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </DefaultButton>
            )}
            <Icon
              style={{ alignSelf: "center" }}
              name="navigate_next"
              color="black"
              size={2.5}
              fixedWidth={false}
            />
            {(path &&
              path.id !== "" &&
              path.subdomains &&
              path.subdomains.knowledge_areas &&
              path.subdomains.knowledge_areas.id !== "") ||
            isLocationClicked("knowledge-area") ? (
              <ActiveButton
                title={
                  path.subdomains.knowledge_areas.title !== ""
                    ? path.subdomains.knowledge_areas.title
                    : "Select knowledge area"
                }
                onClick={() =>
                  isModified
                    ? setOpen(true)
                    : path.subdomains.knowledge_areas.id
                    ? navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area/${path.subdomains.knowledge_areas.id}`
                      )
                    : navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area`
                      )
                }
                onDoubleClick={() => {
                  navigate(
                    `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area`
                  );
                }}
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText color="white">Knowledge Area</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="white" textSize={TextSize.small}>
                      {path.subdomains.knowledge_areas.title !== ""
                        ? path.subdomains.knowledge_areas.title
                        : "Select knowledge area"}
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </ActiveButton>
            ) : (
              <DefaultButton
                disabled={path.subdomains && path.subdomains.id === ""}
                onClick={() =>
                  isModified
                    ? setOpen(true)
                    : navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area`
                      )
                }
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText>Knowledge Area</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="gray" textSize={TextSize.small}>
                      Select knowledge area
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </DefaultButton>
            )}
            <Icon
              style={{ alignSelf: "center" }}
              name="navigate_next"
              color="black"
              size={2.5}
              fixedWidth={false}
            />
            {(path &&
              path.subdomains &&
              path.subdomains.knowledge_areas &&
              path.subdomains.knowledge_areas.knowledge_topics &&
              path.subdomains.knowledge_areas.knowledge_topics.id !== "") ||
            isLocationClicked("knowledge-topic") ? (
              <ActiveButton
                title={
                  path.subdomains.knowledge_areas.knowledge_topics.title !== ""
                    ? path.subdomains.knowledge_areas.knowledge_topics.title
                    : "Select knowledge topic"
                }
                onClick={() =>
                  isModified
                    ? setOpen(true)
                    : navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area/${path.subdomains.knowledge_areas.id}/knowledge-topic/${path.subdomains.knowledge_areas.knowledge_topics.id}`
                      )
                }
                onDoubleClick={() => {
                  navigate(
                    `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area/${path.subdomains.knowledge_areas.id}/knowledge-topic`
                  );
                }}
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText color="white">Knowledge Topic</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="white" textSize={TextSize.small}>
                      {path.subdomains.knowledge_areas.knowledge_topics
                        .title !== ""
                        ? path.subdomains.knowledge_areas.knowledge_topics.title
                        : "Select knowledge topic"}
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </ActiveButton>
            ) : (
              <DefaultButton
                disabled={
                  path.subdomains && !path.subdomains.knowledge_areas.id
                }
                onClick={() =>
                  isModified
                    ? setOpen(true)
                    : navigate(
                        `/modify/pillar/${path.id}/subdomain/${path.subdomains.id}/knowledge-area/${path.subdomains.knowledge_areas.id}/knowledge-topic`
                      )
                }
              >
                <FlexBox
                  direction="column"
                  style={{ width: "100%" }}
                  alignItems="flex-start"
                >
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <UIText>Knowledge Topic</UIText>
                  </FlexGrow>
                  <FlexGrow
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      margin: 0,
                    }}
                  >
                    <StyledText color="gray" textSize={TextSize.small}>
                      Select knowledge topic
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </DefaultButton>
            )}
          </>
        </FlexBox>
      </Fragment>
    </FlexBox>
  );
};

export default PillarNavigator;
